<template>
    <div class="nodisclosure">
        <span class="dollar">{{ currencySymbol }}</span><span class="secret">&#xfe61;&#xfe61;&#xfe61;&#xfe61;&#xfe61;</span><span v-if="des" class="des">({{ des }})</span>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    props: ['des'],
    computed: {
        ...mapState(usePageStore, {
            currencySymbol: store => store.currency.symbol
        })
    }
};
</script>
<style lang="scss">
@import '../theme/mixin.scss';
.nodisclosure {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
    .dollar {
        font-family: var(--font-bold);
        color: #202437;
        font-size: 26px;
        margin-right: 6px;
        line-height: 150%;
    }
    .secret {
        font-weight: bold;
        font-size: 18px;
        margin-right: 4px;
        color: #202437;
    }
    .des {
        font-size: 12px;
        color: #f0454c;
        font-family: var(--font-bold);
        @include ellipsis;
    }
}
</style>
